// Common card template for tournament card, team card, player card, etc

import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Card from './Card';
import CardHeaderView from './CardHeaderView';
import Spinner from './Spinner';
import { useBackBtn } from '../utils/hooks';
import './CardTemplate.scss';

export default function CardTemplate({
  header,
  className,
  backBtn,
  imgUrl,
  imgThumbUrl,
  imgTitle,
  name,
  nameCompanion,
  details,
  aside,
  children,
  editForm,
  onDelete,
  afterDeleteNavPath,
  placeholder,
}) {
  const [spinner, setSpinner] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const handleBackBtn = useBackBtn();
  const edit = searchParams.get('edit');
  const saved = searchParams.get('saved');

  useEffect(() => {
    if (!edit && !name && !saved)
      setSearchParams({ edit: true }, { replace: true });
  }, [name, edit, saved, setSearchParams]);

  const deleteWrap = onDelete
    ? async () => {
        try {
          setSpinner(true);
          await onDelete();
          navigate(afterDeleteNavPath);
          setSpinner(false);
        } catch (error) {
          toast.error(error.message);
          console.error(error.message);
          setSpinner(false);
        }
      }
    : undefined;

  return (
    <Card
      header={header}
      className={'card-template ' + className}
      btnText={backBtn ? 'Back' : undefined}
      onClick={backBtn ? handleBackBtn : undefined}
      btnLeftArrow
    >
      <div className='header'>
        {edit ? (
          editForm
        ) : (
          <CardHeaderView
            imgUrl={imgUrl}
            imgThumbUrl={imgThumbUrl}
            imgTitle={imgTitle}
            name={name}
            nameCompanion={nameCompanion}
            details={details}
            aside={aside}
            allowEdit={!!editForm}
            onDelete={deleteWrap}
            whatToDelete={header.toLowerCase()}
            placeholder={placeholder}
          />
        )}
        <Spinner show={spinner} />
      </div>
      <div className='children-wrap' inert={edit || spinner ? '' : undefined}>
        {children}
        <div className={'cover' + (edit || spinner ? ' show' : '')} />
      </div>
    </Card>
  );
}
